import {
    CURRENT_GAME_HIGHLIGHT,
    INIT_CURRENT_GAME,
} from '../../actions/gameHighlights/gameHighlights';

const INITIAL_STATE = {
    id: null,
    name: null,
    startDate: null,
    endDate: null,
    period: null,
    colourId: null,
    itemId: [],
    retailerTypes: [],
    loading: false,
    colour: null,
};

const currentGameHighlight = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case INIT_CURRENT_GAME:
            return { ...INITIAL_STATE };
        case CURRENT_GAME_HIGHLIGHT:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

export default currentGameHighlight;
